import React from "react";
import { Box } from "@mui/material";
import { CampaignWizard } from "../components/wizard/CampaignWizard";

export default function CampaignCreatePage() {
  return (
    <Box
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 2, sm: 3 },
        width: "100%",
      }}
    >
      <CampaignWizard mode="create" />
    </Box>
  );
}
